export default __webpack_public_path__ + "static/media/bewerber-fifth-step-3.af6a21d2.png";